document.addEventListener('DOMContentLoaded', () => {
  // Menu icon toggle
  const menuIcon = document.querySelector('.menu-icon');
  menuIcon.addEventListener('click', function () {
    this.classList.toggle('opened');
    document.querySelector('.menu-toggle').classList.toggle('menu-open');
    document.body.classList.toggle('offcanvas-triggered');
  });

  // Off-canvas menu toggle
  const topLevelMenuItems = document.querySelectorAll('.off-canvas .top-level.menu-item-has-children > a');
  topLevelMenuItems.forEach((menuItem) => {
    menuItem.addEventListener('click', function (e) {
      e.preventDefault();
      const parent = this.parentNode;
      parent.classList.toggle('is-open');
      
      const subMenu = this.nextElementSibling;
      if (subMenu && subMenu.classList.contains('sub-menu')) {
        subMenu.style.display = subMenu.style.display === 'block' ? 'none' : 'block';
        subMenu.style.transition = 'all 400ms ease'; // Emulating the jQuery slideToggle
      }
    });
  });
});
